import React from "react";
import { Button } from "react-bootstrap";

import classNames from "classnames";
import invariant from "tiny-invariant";

import { useMyScheduleContext } from "../contexts/MySchedule";
import { useButtonHandlers } from "../hooks/useButtonHandlers";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { selectUser } from "../../../../features/auth/authSlice";
import { IGame } from "../../../../types/api";
import { Link } from "react-router-dom";
import { isAvailableForReplacement } from "../lib/isAvailableForReplacement";

const GameActionButtons = ({ game }: { game: IGame }) => {
    const user = useAppSelector(selectUser);
    invariant(user);

    const { schedule } = useMyScheduleContext();
    const {
        handleReplacementRequestClick,
        handleReplacementCancelClick,
        handleCancelBookingClick,
    } = useButtonHandlers();
    const now = new Date();

    const umpire = game.umpires?.find(u => u.id === user.id);
    const gameTime = new Date(game.date);
    const replacementCheck = isAvailableForReplacement(gameTime, game.site);
    const canCancel =
        umpire?.cancelUntil &&
        now.getTime() < new Date(umpire?.cancelUntil).getTime();

    return (
        <React.Fragment>
            {schedule === "current" ? (
                <>
                    {canCancel && (
                        <Button
                            variant="danger"
                            className={classNames("actionButton")}
                            onClick={() =>
                                handleCancelBookingClick(game, user.id)
                            }
                        >
                            Cancel Booking
                        </Button>
                    )}
                    {umpire?.replacement === null && replacementCheck && (
                        <Button
                            variant="primary"
                            className={classNames({
                                actionButton: true,
                            })}
                            onClick={() =>
                                handleReplacementRequestClick(game, user.id)
                            }
                        >
                            Request Replacement
                        </Button>
                    )}
                    {Boolean(umpire?.replacement) && (
                        <Button
                            variant="danger"
                            className={classNames({
                                actionButton: true,
                            })}
                            onClick={() =>
                                handleReplacementCancelClick(game, user.id)
                            }
                        >
                            Cancel Replacement
                        </Button>
                    )}
                </>
            ) : (
                <>
                    <Link
                        to={`/my-schedule/${game.id}/coach-review`}
                        className={classNames({
                            actionButton: true,
                            btn: true,
                            "btn-primary": true,
                        })}
                    >
                        Coach Review
                    </Link>
                    <br />
                    <Link
                        to={`/my-schedule/${game.id}/ejection-report`}
                        className={classNames({
                            actionButton: true,
                            btn: true,
                            "btn-danger": true,
                        })}
                    >
                        Ejection Report
                    </Link>
                </>
            )}
        </React.Fragment>
    );
};

export default GameActionButtons;
